module.exports = __webpack_public_path__ + "static/media/ExampleRoom.07aafbf8.csv";


//////////////////
// WEBPACK FOOTER
// ./src/statics/ExampleRoom.csv
// module id = 2129
// module chunks = 0